import React, { useState, useEffect } from "react";
import { FaLeaf, FaBolt } from "react-icons/fa";
import axios from "axios";

function Register() {
  const [formData, setFormData] = useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // simple validations
    if (formData.email !== formData.confirmEmail) {
      alert("Emails do not match!");
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    try {
      const res = await axios.post("https://backend-zkgn.onrender.com/api/admin/register", {
        username: formData.username,
        firstname: formData.firstName,
        lastname: formData.lastName,
        email: formData.email,
        password: formData.password,
      });

      alert(res.data.message || "Signup successful!");
      setFormData({
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        confirmEmail: "",
        password: "",
        confirmPassword: "",
      });
    } catch (err) {
      alert(err.response?.data?.message || "Registration failed");
    }
  };

  // for card animation
  useEffect(() => {
    const card = document.querySelector(".signup-card");
    if (card) card.classList.add("fade-in");
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=1920&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.55)",
        }}
      ></div>

      {/* Signup Card */}
      <div
        className="signup-card card shadow-lg p-4 position-relative"
        style={{
          width: "100%",
          maxWidth: "440px",
          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: "15px",
          backgroundColor: "rgba(255, 255, 255, 0.97)",
          zIndex: 2,
          opacity: 0,
          transform: "translateY(30px)",
          transition: "opacity 1s ease, transform 1s ease",
        }}
      >
        {/* Floating icon */}
        <div className="text-center mb-2">
          <FaLeaf
            className="text-success"
            size={36}
            style={{ animation: "float 3s ease-in-out infinite" }}
          />
        </div>

        <h3 className="text-center mb-3 text-primary fw-bold">
          Create an Account
        </h3>

        <form onSubmit={handleSubmit} className="small">
          <div className="mb-2">
            <label className="form-label fw-semibold">Username</label>
            <input
              type="text"
              className="form-control form-control-sm"
              name="username"
              placeholder="Enter username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="form-label fw-semibold">First Name</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="firstName"
                placeholder="First name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label fw-semibold">Last Name</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="lastName"
                placeholder="Last name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="mb-2">
            <label className="form-label fw-semibold">Email</label>
            <input
              type="email"
              className="form-control form-control-sm"
              name="email"
              placeholder="Enter email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-2">
            <label className="form-label fw-semibold">Confirm Email</label>
            <input
              type="email"
              className="form-control form-control-sm"
              name="confirmEmail"
              placeholder="Re-enter email"
              value={formData.confirmEmail}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-2">
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              className="form-control form-control-sm"
              name="password"
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Confirm Password</label>
            <input
              type="password"
              className="form-control form-control-sm"
              name="confirmPassword"
              placeholder="Re-enter password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>

          <div className="d-grid mt-3">
            <button type="submit" className="btn btn-primary btn-sm shadow-sm">
              Register
            </button>
          </div>
        </form>

        <p className="text-center mt-3 mb-0 text-secondary small">
          Already have an account?{" "}
          <a
            href="/login"
            className="text-decoration-none fw-semibold text-primary"
          >
            Log In
          </a>
        </p>
      </div>

      {/* Floating bolt icon */}
      <FaBolt
        className="text-warning position-absolute"
        style={{
          top: "20px",
          right: "30px",
          fontSize: "28px",
          animation: "float 4s ease-in-out infinite",
          zIndex: 3,
        }}
      />
    </div>
  );
}

export default Register;
